/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProgramSessionSet } from '../entities';
// @ts-ignore
import type { ProgramSessionSetCreateRequest } from '../entities';
// @ts-ignore
import type { ProgramSessionSetSearchRequest } from '../entities';
// @ts-ignore
import type { ProgramSessionSetSearchResponse } from '../entities';
// @ts-ignore
import type { ProgramSetUpdateProgramRequest } from '../entities';
// @ts-ignore
import type { ProgramSetUpdateProgramResponse } from '../entities';
// @ts-ignore
import type { SetUpdateRequest } from '../entities';
/**
 * ProgramSessionSetControllerApi - axios parameter creator
 * @export
 */
export const ProgramSessionSetControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        align: async (programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programSessionSetSearchRequest' is not null or undefined
            assertParamExists('align', 'programSessionSetSearchRequest', programSessionSetSearchRequest)
            const localVarPath = `/program/set/align`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionSetSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alignUuid1: async (programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programSessionSetSearchRequest' is not null or undefined
            assertParamExists('alignUuid1', 'programSessionSetSearchRequest', programSessionSetSearchRequest)
            const localVarPath = `/program/set/align/uuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionSetSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {ProgramSessionSetCreateRequest} programSessionSetCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create8: async (sessionId: number, programSessionSetCreateRequest: ProgramSessionSetCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('create8', 'sessionId', sessionId)
            // verify required parameter 'programSessionSetCreateRequest' is not null or undefined
            assertParamExists('create8', 'programSessionSetCreateRequest', programSessionSetCreateRequest)
            const localVarPath = `/program/session/{session_id}/create`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionSetCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} sessionId 
         * @param {ProgramSessionSetCreateRequest} programSessionSetCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithProgram: async (id: number, sessionId: number, programSessionSetCreateRequest: ProgramSessionSetCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createWithProgram', 'id', id)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('createWithProgram', 'sessionId', sessionId)
            // verify required parameter 'programSessionSetCreateRequest' is not null or undefined
            assertParamExists('createWithProgram', 'programSessionSetCreateRequest', programSessionSetCreateRequest)
            const localVarPath = `/program/{id}/session/{session_id}/create`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionSetCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete10: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delete10', 'id', id)
            const localVarPath = `/program/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByUuid1: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteByUuid1', 'uuid', uuid)
            const localVarPath = `/program/delete/uuid/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get7: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get7', 'id', id)
            const localVarPath = `/program/set/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUuid: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getByUuid', 'id', id)
            const localVarPath = `/program/set/uuid/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteByUuid: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('hardDeleteByUuid', 'uuid', uuid)
            const localVarPath = `/program/delete/uuid/hard/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch4: async (id: number, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patch4', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('patch4', 'body', body)
            const localVarPath = `/program/set/{id}/patch`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByExercise: async (uuid: string, programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('searchByExercise', 'uuid', uuid)
            // verify required parameter 'programSessionSetSearchRequest' is not null or undefined
            assertParamExists('searchByExercise', 'programSessionSetSearchRequest', programSessionSetSearchRequest)
            const localVarPath = `/program/set/exercise/{uuid}/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionSetSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByExerciseUuid: async (uuid: string, programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('searchByExerciseUuid', 'uuid', uuid)
            // verify required parameter 'programSessionSetSearchRequest' is not null or undefined
            assertParamExists('searchByExerciseUuid', 'programSessionSetSearchRequest', programSessionSetSearchRequest)
            const localVarPath = `/program/set/exercise/uuid/{uuid}/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionSetSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBySets: async (programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programSessionSetSearchRequest' is not null or undefined
            assertParamExists('searchBySets', 'programSessionSetSearchRequest', programSessionSetSearchRequest)
            const localVarPath = `/program/set/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSessionSetSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {SetUpdateRequest} setUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update2: async (id: number, setUpdateRequest: SetUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update2', 'id', id)
            // verify required parameter 'setUpdateRequest' is not null or undefined
            assertParamExists('update2', 'setUpdateRequest', setUpdateRequest)
            const localVarPath = `/program/set/{id}/update`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProgramSetUpdateProgramRequest} programSetUpdateProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProgramDetails: async (id: number, programSetUpdateProgramRequest: ProgramSetUpdateProgramRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProgramDetails', 'id', id)
            // verify required parameter 'programSetUpdateProgramRequest' is not null or undefined
            assertParamExists('updateProgramDetails', 'programSetUpdateProgramRequest', programSetUpdateProgramRequest)
            const localVarPath = `/program/{id}/set/update`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programSetUpdateProgramRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails4: async (id: number, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUserDetails4', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateUserDetails4', 'body', body)
            const localVarPath = `/program/set/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProgramSessionSetControllerApi - functional programming interface
 * @export
 */
export const ProgramSessionSetControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProgramSessionSetControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async align(programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSetSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.align(programSessionSetSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.align']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async alignUuid1(programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSetSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.alignUuid1(programSessionSetSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.alignUuid1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {ProgramSessionSetCreateRequest} programSessionSetCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create8(sessionId: number, programSessionSetCreateRequest: ProgramSessionSetCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create8(sessionId, programSessionSetCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.create8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} sessionId 
         * @param {ProgramSessionSetCreateRequest} programSessionSetCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWithProgram(id: number, sessionId: number, programSessionSetCreateRequest: ProgramSessionSetCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWithProgram(id, sessionId, programSessionSetCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.createWithProgram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete10(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete10(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.delete10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByUuid1(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByUuid1(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.deleteByUuid1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get7(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get7(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.get7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByUuid(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByUuid(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.getByUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hardDeleteByUuid(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hardDeleteByUuid(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.hardDeleteByUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patch4(id: number, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patch4(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.patch4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByExercise(uuid: string, programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSetSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByExercise(uuid, programSessionSetSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.searchByExercise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByExerciseUuid(uuid: string, programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSetSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByExerciseUuid(uuid, programSessionSetSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.searchByExerciseUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBySets(programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSetSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchBySets(programSessionSetSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.searchBySets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {SetUpdateRequest} setUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update2(id: number, setUpdateRequest: SetUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramSessionSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update2(id, setUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.update2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProgramSetUpdateProgramRequest} programSetUpdateProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProgramDetails(id: number, programSetUpdateProgramRequest: ProgramSetUpdateProgramRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProgramSetUpdateProgramResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProgramDetails(id, programSetUpdateProgramRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.updateProgramDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserDetails4(id: number, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: boolean; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserDetails4(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgramSessionSetControllerApi.updateUserDetails4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProgramSessionSetControllerApi - factory interface
 * @export
 */
export const ProgramSessionSetControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProgramSessionSetControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        align(programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSetSearchResponse> {
            return localVarFp.align(programSessionSetSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alignUuid1(programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSetSearchResponse> {
            return localVarFp.alignUuid1(programSessionSetSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {ProgramSessionSetCreateRequest} programSessionSetCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create8(sessionId: number, programSessionSetCreateRequest: ProgramSessionSetCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSet> {
            return localVarFp.create8(sessionId, programSessionSetCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} sessionId 
         * @param {ProgramSessionSetCreateRequest} programSessionSetCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithProgram(id: number, sessionId: number, programSessionSetCreateRequest: ProgramSessionSetCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSet> {
            return localVarFp.createWithProgram(id, sessionId, programSessionSetCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete10(id: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.delete10(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByUuid1(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.deleteByUuid1(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get7(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSet> {
            return localVarFp.get7(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUuid(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSet> {
            return localVarFp.getByUuid(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteByUuid(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.hardDeleteByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch4(id: number, body: object, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSet> {
            return localVarFp.patch4(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} uuid 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByExercise(uuid: string, programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSetSearchResponse> {
            return localVarFp.searchByExercise(uuid, programSessionSetSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} uuid 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByExerciseUuid(uuid: string, programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSetSearchResponse> {
            return localVarFp.searchByExerciseUuid(uuid, programSessionSetSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBySets(programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSetSearchResponse> {
            return localVarFp.searchBySets(programSessionSetSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {SetUpdateRequest} setUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update2(id: number, setUpdateRequest: SetUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProgramSessionSet> {
            return localVarFp.update2(id, setUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProgramSetUpdateProgramRequest} programSetUpdateProgramRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProgramDetails(id: number, programSetUpdateProgramRequest: ProgramSetUpdateProgramRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProgramSetUpdateProgramResponse>> {
            return localVarFp.updateProgramDetails(id, programSetUpdateProgramRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails4(id: number, body: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: boolean; }>> {
            return localVarFp.updateUserDetails4(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProgramSessionSetControllerApi - object-oriented interface
 * @export
 * @class ProgramSessionSetControllerApi
 * @extends {BaseAPI}
 */
export class ProgramSessionSetControllerApi extends BaseAPI {
    /**
     * 
     * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public align(programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).align(programSessionSetSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public alignUuid1(programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).alignUuid1(programSessionSetSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} sessionId 
     * @param {ProgramSessionSetCreateRequest} programSessionSetCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public create8(sessionId: number, programSessionSetCreateRequest: ProgramSessionSetCreateRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).create8(sessionId, programSessionSetCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} sessionId 
     * @param {ProgramSessionSetCreateRequest} programSessionSetCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public createWithProgram(id: number, sessionId: number, programSessionSetCreateRequest: ProgramSessionSetCreateRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).createWithProgram(id, sessionId, programSessionSetCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public delete10(id: number, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).delete10(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public deleteByUuid1(uuid: string, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).deleteByUuid1(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public get7(id: number, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).get7(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public getByUuid(id: string, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).getByUuid(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} uuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public hardDeleteByUuid(uuid: string, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).hardDeleteByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public patch4(id: number, body: object, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).patch4(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} uuid 
     * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public searchByExercise(uuid: string, programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).searchByExercise(uuid, programSessionSetSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} uuid 
     * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public searchByExerciseUuid(uuid: string, programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).searchByExerciseUuid(uuid, programSessionSetSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProgramSessionSetSearchRequest} programSessionSetSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public searchBySets(programSessionSetSearchRequest: ProgramSessionSetSearchRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).searchBySets(programSessionSetSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {SetUpdateRequest} setUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public update2(id: number, setUpdateRequest: SetUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).update2(id, setUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProgramSetUpdateProgramRequest} programSetUpdateProgramRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public updateProgramDetails(id: number, programSetUpdateProgramRequest: ProgramSetUpdateProgramRequest, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).updateProgramDetails(id, programSetUpdateProgramRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramSessionSetControllerApi
     */
    public updateUserDetails4(id: number, body: string, options?: RawAxiosRequestConfig) {
        return ProgramSessionSetControllerApiFp(this.configuration).updateUserDetails4(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}

